const styles = {
  root: {
    height: "35px",
    "& .MuiOutlinedInput-root": {
      color: "green.dark",
      backgroundColor: "white",
      borderRadius: 4,
      height: "35px",
      padding: "0 4px",
    },
  },
  searchIcon: {
    textTransform: "none",
    ml: 2,
    minWidth: 0,
    mr: 1,
  },
};

export default styles;
